const showCoursePage = process.env.REACT_APP_SHOW_COURSE_PAGE === 'true';

const routesPath = {

    home: '/',
    nextSession: '/sessions/next/:session_slug',
    // courses: '/courses',
    courseDetails: '/courses/next/:course_slug',
    // sessionsDetails: '/sessions/details/ansible-course-2024',
    // interviewquestions: '/interview/questions',
    // ComingSoon: 'ComingSoon',
    // Support: '/submit/ticket',
    contactUs: '/contact_us',
    CompaniesStudentsWorked: '/companies/students/worked',
    error404: '/error404',
    faq: '/faq',
    testimonials: '/testimonials',
    feedback: '/feedback',
    ...(showCoursePage && { availablesCourses: '/availables-courses' }), // Ajout conditionnel
    termsOfUse:'/terms-of-use',
    laptopTools:'/laptop-requirements'

}

export default routesPath